export function easeOutExpo(x) {
	return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}

export function easeInCubic(x) {
	return x * x * x;
}
